/**
 * Shared drop-shadow for a dialog panel — the Figma "Modal / Edit profile"
 * elevation (node 4761:118170), a three-layer shadow, softest and widest on
 * top:
 *   0px 16px 18px rgba(0,0,0,0.05)
 *   0px 8px  9px  rgba(0,0,0,0.05)
 *   0px 2px  2px  rgba(0,0,0,0.03)
 *
 * Written as an arbitrary box-shadow rather than a design-system token on
 * purpose: design-system/tokens.css deliberately does NOT declare the
 * Figma radius/shadow scale yet, and this node's effect isn't one of the
 * named Shadows/shadow* tokens anyway (its blur radii and spreads differ).
 * Promoting it to a token is a design-system-wide decision, not any one
 * dialog's to make. box-shadow, not the drop-shadow filter: a dialog panel
 * is an opaque rounded card, so the cheaper paint path is equivalent here.
 *
 * Opt-in per dialog rather than baked into the shared DialogContent —
 * applying it there would restyle every dialog in both apps at once.
 */
export const DIALOG_ELEVATION_CLASS =
  'shadow-[0px_16px_18px_rgba(0,0,0,0.05),0px_8px_9px_rgba(0,0,0,0.05),0px_2px_2px_rgba(0,0,0,0.03)]';
